<template>
  <div class="toast d-flex flex-column ai-center jc-center">
    <!-- :class="{ noCopyContract: !isCopyContract }" -->
    <div class="toast-content d-flex ai-center jc-center">
      <!-- <img src="../assets/success.png" /> -->
      <span>{{ $t('copied') }}</span>
    </div>
    <!-- <div class="toast-content d-flex ai-center jc-center" v-else>
      <img src="../assets/success.png" />
      <span class="text">{{ $t('copied') }}</span>
    </div>
    <div v-if="isCopyContract" class="text button" @click="close">
      {{ $t('understood') }}
    </div> -->
  </div>
</template>

<script>
export default {
  // props: {
  //   isCopyContract: {
  //     type: Boolean,
  //   },
  // },
  methods: {
    close() {
      this.$emit('closeToast')
    },
  },
}
</script>

<style lang="scss" scoped>
.toast {
  position: fixed;
  z-index: 9998;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 3.55rem;
  height: 1.14rem;
  background: var(--toast-bg);
  border-radius: 0.16rem;
  &.noCopyContract {
    width: 60%;
    padding: 0.2rem 0.3rem;
  }
  .toast-content {
    img {
      width: 0.4rem;
      height: 0.4rem;
    }
    span {
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      font-size: 0.26rem;
      color: var(--toast-color);
    }
  }
  .button {
    display: inline-block;
    margin-top: 0.2rem;
    padding: 0.1rem 0.3rem;
    background: #2980fe;
    border-radius: 0.12rem;
    text-align: center;
    color: #fff;
  }
}
</style>
